var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Termín " + _vm._s(_vm.getPopUpType()))]), _c('button', {
    staticClass: "w-button",
    attrs: {
      "form": "event-form",
      "disabled": _vm.submitted || _vm.clientBusy
    }
  }, [_vm._v(" Vytvoriť ")])]), _c('div', {
    staticClass: "w-form"
  }, [_vm.clientMissing ? _c('span', {
    staticClass: "clientError"
  }, [_vm._v(" Vyberte alebo vytvorte klienta ")]) : _vm._e(), _vm.needsClientPicker ? _c('client-picker', {
    attrs: {
      "disabled": _vm.submitted,
      "broker-id": _vm.type.type === 'brokerConsultation' ? _vm.$store.getters['userState/getId'] : undefined,
      "complex": ""
    },
    on: {
      "client-picked": function clientPicked($event) {
        return _vm.setClient($event);
      },
      "busy": function busy($event) {
        _vm.clientBusy = $event;
      }
    }
  }) : _vm._e(), _vm.type.type === 'availability' ? _c('div', {
    staticClass: "availability-note"
  }, [_vm._v(" Tento termín uvidia klienti, ktorým ste pridelený. Daily videohovor sa bezpečne vytvorí až po rezervácii. ")]) : _vm._e(), _c(_vm.type.component, {
    tag: "component",
    attrs: {
      "availability": _vm.type.type === 'availability',
      "initial-start": _vm.initialStart,
      "initial-end": _vm.initialEnd
    },
    on: {
      "event-saved": function eventSaved($event) {
        return _vm.saveEvent($event);
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }